import { Component, Inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

export interface BottomSheetData {
  titolo?: string;
  descrizione?: string;
  fontWeight?: string;
}

@Component({
  selector: 'app-bottom-sheet-alert',
  standalone: false,

  templateUrl: './bottom-sheet-alert.component.html',
  styleUrl: './bottom-sheet-alert.component.scss',
})
export class BottomSheetAlertComponent {
  public titolo: SafeHtml = '';
  public descrizione: SafeHtml = '';
  public fontWeight: SafeHtml = '';

  constructor(
    private readonly sanitizer: DomSanitizer,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: BottomSheetData,
  ) {}

  ngOnInit(): void {
    this.titolo = this.getTraduzione(this.data.titolo ?? '');
    this.descrizione = this.getTraduzione(this.data?.descrizione ?? '');
    this.fontWeight = this.data.fontWeight ?? 'bold';
  }

  getTraduzione(data?: string): SafeHtml {
    if (data) {
      return this.sanitizer.bypassSecurityTrustHtml(data);
    } else {
      return '';
    }
  }
}
